
import React from 'react';
import { Outlet } from 'react-router-dom';
import ProfileSideBar from './ProfileInfo/ProfileSideBar';


function ProfileLayout() {
  return (
    <div className="flex  p-16 gap-10 ">
      {/* Fixed Sidebar */}
      <div className="w-1/4 ">
        <ProfileSideBar/>
      </div>

      {/* Dynamic Content */}
      <div className="w-3/4 ">
        <Outlet />
      </div>
    </div>
  );
}

export default ProfileLayout;
